import { inject, Injectable } from '@angular/core';
import { Adjust } from '@awesome-cordova-plugins/adjust/ngx';
import { Logger } from 'src/app/core/helpers/logger';
import { isCapacitor, isIOS } from 'src/app/core/helpers/utils';

/** ATTrackingManager.AuthorizationStatus value for "authorized", as returned by the Adjust plugin's ATT APIs
 *  (0 = notDetermined, 1 = restricted, 2 = denied, 3 = authorized) */
const ATT_STATUS_AUTHORIZED = 3;

@Injectable({
  providedIn: 'root',
})
export class TrackingConsentService {
  private adjust = inject(Adjust);
  private logger = inject(Logger);

  /**
   * On native iOS, shows the App Tracking Transparency system prompt (only on the first ask —
   * iOS stores the answer and resolves instantly on later launches) and resolves whether
   * cross-app tracking is authorized. The prompt text comes from NSUserTrackingUsageDescription
   * in Info.plist. Other platforms resolve true: ATT is an iOS-only concept and their tracking
   * behavior is unchanged.
   */
  public async requestPermission(): Promise<boolean> {
    // isIOS (native check) and not platform.is('ios') (UA sniffing) — the latter fails on iPads
    if (!isCapacitor || !isIOS) {
      return true;
    }
    try {
      const status = await this.adjust.requestAppTrackingAuthorization();
      return status === ATT_STATUS_AUTHORIZED;
    } catch (err) {
      this.logger.error({ msg: '@tracking-consent.service: ATT request failed, treating tracking as not authorized', err });
      return false;
    }
  }
}
